import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bb4a2728"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-contents" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title list-title" }, "1.URLからファイルを自動収集する方法", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, [
  /*#__PURE__*/_createElementVNode("p", null, "インターネットで誰でも自由にアクセスできる電子書籍・電子雑誌は、以下のWebフォームへURL等の情報をお寄せください。国立国会図書館が電子書籍・電子雑誌のファイルを確認し、自動収集します。")
], -1))
const _hoisted_4 = { class: "navigation" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 自動収集の流れ ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Webフォーム ")
const _hoisted_7 = { class: "list-contents" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title list-title" }, "2.ファイルをアップロードする方法（送信）", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, [
  /*#__PURE__*/_createElementVNode("p", null, "送信システムにログインして、ファイル等をアップロードすることも可能です。アクセス認証（ID/PW）を設けて電子書籍・電子雑誌を公開している等、1.の方法が利用できない場合に用います。"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 送信システムをご利用いただく場合には、当館が発行するIDとパスワードが必要です。件名を【ID・パスワードの発行について】として、 "),
    /*#__PURE__*/_createElementVNode("a", {
      id: "link-mailHelp",
      href: "mailto:online@ndl.go.jp?subject=ID・パスワードの発行について",
      "aria-label": "ID・パスワードの発行についての問い合わせ先 online@ndl.go.jp"
    }, " online@ndl.go.jp "),
    /*#__PURE__*/_createTextVNode(" 宛にメールでご連絡ください。確認の上、IDとパスワードを発行します。 ")
  ])
], -1))
const _hoisted_10 = { class: "navigation" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 送信の流れ ")
const _hoisted_12 = { class: "navigation" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" デジタルデポジットシステムの使用に係るオンライン資料の送信用IDに関する規定 ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" メール ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 送信システムへログイン ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title list-title" }, "3.お問合せ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 上記の方法で納入できない場合は、件名を【オンライン資料の納入について】として、 "),
    /*#__PURE__*/_createElementVNode("a", {
      id: "link-mailSend",
      href: "mailto:online@ndl.go.jp?subject=オンライン資料の納入について",
      "aria-label": "納入できない場合の問い合わせ先 online@ndl.go.jp"
    }, " online@ndl.go.jp "),
    /*#__PURE__*/_createTextVNode(" 宛にメールでお問合せください。 ")
  ])
], -1))
const _hoisted_18 = { class: "navigation" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 送付の流れ ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" メール ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DssIcon = _resolveComponent("DssIcon")!
  const _component_TextLinkWithArrow = _resolveComponent("TextLinkWithArrow")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("ul", null, [
    _createElementVNode("li", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_TextLinkWithArrow, {
          class: "button-collectFlowPdf",
          href: `${_ctx.baseUrl}/static/files/flow_jidou.pdf`
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createVNode(_component_DssIcon, {
              icon: 'file-pdf',
              label: 'pdf'
            })
          ]),
          _: 1
        }, 8, ["href"])
      ]),
      _createVNode(_component_AppButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push('online/agreement'))),
        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('online/agreement')), ["prevent"]), ["space","enter"])),
        styled: 'is-accent',
        buttonId: 'button-toAgreement'
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createVNode(_component_DssIcon, { icon: 'arrow-right' })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", _hoisted_7, [
      _hoisted_8,
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_TextLinkWithArrow, {
          class: "button-sendFlowPdf",
          href: `${_ctx.baseUrl}/static/files/flow_soushin.pdf`
        }, {
          default: _withCtx(() => [
            _hoisted_11,
            _createVNode(_component_DssIcon, {
              icon: 'file-pdf',
              label: 'pdf'
            })
          ]),
          _: 1
        }, 8, ["href"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_TextLinkWithArrow, {
          class: "button-regulationPdf",
          href: `${_ctx.baseUrl}/static/files/online_kitei.pdf`
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createVNode(_component_DssIcon, {
              icon: 'file-pdf',
              label: 'pdf'
            })
          ]),
          _: 1
        }, 8, ["href"])
      ]),
      _createVNode(_component_AppButton, {
        buttonId: 'button-mailHelp',
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mailto('online@ndl.go.jp', 'ID・パスワードの発行について', ''))),
        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.mailto('online@ndl.go.jp', 'ID・パスワードの発行について', '')), ["prevent"]), ["space","enter"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DssIcon, { icon: 'envelope' }),
          _hoisted_14
        ]),
        _: 1
      }),
      _createVNode(_component_AppButton, {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.router.push('/dms/online/login'))),
        onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.router.push('/dms/online/login')), ["prevent"]), ["space","enter"])),
        styled: 'is-accent',
        buttonId: 'button-tologin'
      }, {
        default: _withCtx(() => [
          _hoisted_15,
          _createVNode(_component_DssIcon, { icon: 'arrow-right' })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", null, [
      _hoisted_16,
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_TextLinkWithArrow, {
          class: "button-mailFlowPdf",
          href: `${_ctx.baseUrl}/static/files/flow_soufu.pdf`
        }, {
          default: _withCtx(() => [
            _hoisted_19,
            _createVNode(_component_DssIcon, {
              icon: 'file-pdf',
              label: 'pdf'
            })
          ]),
          _: 1
        }, 8, ["href"])
      ]),
      _createVNode(_component_AppButton, {
        buttonId: 'button-mailSend',
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mailto('online@ndl.go.jp', 'オンライン資料の納入について', ''))),
        onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.mailto('online@ndl.go.jp', 'オンライン資料の納入について', '')), ["prevent"]), ["space","enter"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DssIcon, { icon: 'envelope' }),
          _hoisted_20
        ]),
        _: 1
      })
    ])
  ]))
}